"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _toConsumableArray2 = require("babel-runtime/helpers/toConsumableArray");

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

exports.defaultDataRenderCallback = defaultDataRenderCallback;
exports.recurseRenderData = recurseRenderData;
exports.renderDataChildren = renderDataChildren;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _Category = require("./Category");

var _Category2 = _interopRequireDefault(_Category);

var _Item = require("./Item");

var _Item2 = _interopRequireDefault(_Item);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function defaultDataRenderCallback(node, props) {
    var type = typeof node.type == "string" ? node.type.toLowerCase() : node.type;
    var ItemType = type == "category" ? _Category2.default : _Item2.default;
    var title = node.title;
    switch (type) {
        case "link":
            title = _react2.default.createElement(
                "a",
                { href: node.href },
                title
            );break;
        case "cnlink":
            // TODO: complete CNLink
            break;
    }
    return _react2.default.createElement(ItemType, (0, _extends3.default)({}, node, props, { title: title, children: null }));
}

// ATTENTION: this function does not handle onClick!
function recurseRenderData(dataSource, dataRenderCallback) {
    if (!Array.isArray(dataSource)) {
        return [];
    }
    var ret = Array.prototype.map.call(dataSource, function (node) {
        return _react2.default.cloneElement.apply(_react2.default, [dataRenderCallback(node, { dataNode: node }), {}].concat((0, _toConsumableArray3.default)(recurseRenderData(node.children, dataRenderCallback))));
    });
    return ret;
}

function renderDataChildren() {
    var _this = this;

    var dataSource = this.props.dataSource || this.props.dataNode && this.props.dataNode.children;
    if (!Array.isArray(dataSource)) {
        // TODO: should we add an assertion for invalid types?
        return null;
    }
    return dataSource.map(function (node) {
        return _this.props.dataRenderCallback(node, {
            dataNode: node,
            dataOnClick: _this.props.itemOnClick
        });
    });
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_crui-slider-bar-nav@0.0.38@@alicd/crui-slider-bar-nav/lib/render-from-data.js
// module id = 156
// module chunks = 0